import React, { FunctionComponent } from "react";
import { useFieldArray } from "react-hook-form";

import Button from "../Buttons/Button";
import styles from "./InputList.module.scss";
import Input from "../Input/Input";

const InputList: FunctionComponent<{
  control: any;
  register: any;
  name: string;
}> = ({ control, name, register }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <div className={styles.inputList}>
      <h5>{name}</h5>
      <ul>
        {fields.map((item, index) => (
          <li key={item.id} className={styles.inputList_row}>
            <Input
              name={`${name}[${index}]`}
              defaultValue={item.name}
              inputRef={register()}
              variant="outlined"
              fullWidth
              margin="normal"
              required
            />
            <div className={styles.inputList_button}>
              <Button onClick={() => remove(index)} aria-label="remove">
                Remove
              </Button>
            </div>
          </li>
        ))}
      </ul>
      <section className={styles.inputList_row}>
        <div className={styles.inputList_button}>
          <Button
            aria-label="append"
            buttonVariant="secondary"
            type="button"
            onClick={() => append({ name: "" })}
          >
            append
          </Button>
        </div>
      </section>
    </div>
  );
};

export default InputList;
